import utils from '../services/utils.js';

export function getCryptoAddressVerificationRequest(sendData) {
    return (dispatch) => {
        sendData.ajax_data_tables = true;
        dispatch(getCryptoAddressVerificationSend());
        return utils.app_post(utils.getLocalizeUrl('/api/crypto-address/ajax-crypto-address-pagination'), sendData)
            .then((resp) => {
                dispatch(getCryptoAddressVerificationSuccess(resp));

                return resp;
            }
        );
    }
}

function getCryptoAddressVerificationSend() {
    return {
        type: 'GET_CRYPTO_ADDRESS_VERIFICATION_SEND',
    };
}

function getCryptoAddressVerificationSuccess(data) {
    return {
        type: 'GET_CRYPTO_ADDRESS_VERIFICATION_SUCCESS',
        data: data
    };
}

export function getDataToVerifyCryptoAddressRequest() {
    return (dispatch) => {
        dispatch(getDataToVerifyCryptoAddressSend());
        return utils.app_post(utils.getLocalizeUrl('/api/crypto-address/get-data-to-verify-crypto-address'))
            .then((resp) => {
                    dispatch(getDataToVerifyCryptoAddressSuccess(resp));

                    return resp;
                }
            );
    }
}

function getDataToVerifyCryptoAddressSend() {
    return {
        type: 'GET_DATA_TO_VERIFY_CRYPTO_ADDRESS_SEND',
    };
}

function getDataToVerifyCryptoAddressSuccess(data) {
    return {
        type: 'GET_DATA_TO_VERIFY_CRYPTO_ADDRESS_SUCCESS',
        data: data.data
    };
}

export function addCryptoAddressVerificationRequest(sendData, cb) {
    return (dispatch) => {
        return utils.app_post_cc(utils.getLocalizeUrl('/api/crypto-address/add-crypto-address-verification'), sendData, (resp) => {
            dispatch(addCryptoAddressVerificationRequestSuccess());
            if (typeof cb === 'function') {
                cb(resp);
            }
        });
    }
}

function addCryptoAddressVerificationRequestSuccess() {
    return {
        type: 'ADD_CRYPTO_ADDRESS_VERIFICATION_REQUEST_SUCCESS'
    };
}
